export class vwPerformanceResultDto {
  PersonalPerformance   : number;
  GroupPerformance      : number;
}